// The avatar create flow as a full-screen sheet — for places that must keep
// their page alive underneath (the world viewer, the editor).
import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import AvatarCreateFlow, { type AvatarCreateFlowProps } from './AvatarCreateFlow';

const AvatarCreateModal: React.FC<Omit<AvatarCreateFlowProps, 'inModal' | 'onCancel'> & { onClose: () => void }> = ({ onClose, ...flow }) => {
  const ref = useRef<HTMLDivElement>(null);
  // Worlds and the editor bind global keys (WASD, shortcuts); typing here must not move anyone.
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const stop = (e: Event) => e.stopPropagation();
    const evts = ['keydown', 'keyup', 'keypress', 'wheel'];
    evts.forEach((t) => el.addEventListener(t, stop));
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    if (document.pointerLockElement) document.exitPointerLock?.();
    return () => { evts.forEach((t) => el.removeEventListener(t, stop)); document.body.style.overflow = prev; };
  }, []);
  return createPortal(
    <div className="gxw-modal" ref={ref} role="dialog" aria-modal="true" aria-label="Create an avatar">
      <AvatarCreateFlow {...flow} inModal onCancel={onClose} cancelLabel="Close" />
    </div>,
    document.body,
  );
};

export default AvatarCreateModal;
